import { useEffect, useState } from "react";

/** Joins class names, skipping falsy values. */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}

/**
 * True only after `active` has stayed true for `delayMs`. Skeletons appear after 300 ms, never
 * before, to avoid flashes (DESIGN_SYSTEM §9.1 Loading).
 */
export function useDelayedFlag(active: boolean, delayMs = 300): boolean {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (!active) {
      setShown(false);
      return;
    }
    const id = setTimeout(() => setShown(true), delayMs);
    return () => clearTimeout(id);
  }, [active, delayMs]);
  return active && shown;
}

/** Counts user-perceived characters (graphemes), so Devanagari conjuncts count correctly (§9.2). */
export function graphemeCount(text: string): number {
  const Seg = (Intl as unknown as { Segmenter?: typeof Intl.Segmenter }).Segmenter;
  if (!Seg) return Array.from(text).length;
  return Array.from(new Seg("en", { granularity: "grapheme" }).segment(text)).length;
}
